import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlFrontendBadgeComponent } from '@app/core/wrappers/bl-frontend-badge.component';
import { BadgeProps } from '@bl/components';
import { BlFrontendHeaderComponent } from 'src/app/core/wrappers/bl-frontend-header.component';

@Component({
  selector: 'app-partnerprogram-card',
  template: `
    <div
      class="flex flex-col bg-white p-6 rounded-xl shadow h-56 relative"
      [ngStyle]="
        background
          ? {
              'background-image': 'url(' + background + ')',
              'background-repeat': 'no-repeat',
              'background-position': 'top right',
            }
          : {}
      ">
      <div>
        <div class="flex flex-col">
          <bl-frontend-header size="h4" [text]="header"></bl-frontend-header>
          <ng-container *ngIf="badges?.length">
            <div class="flex gap-2 mt-1">
              <bl-frontend-badge
                *ngFor="let badge of badges"
                [text]="badge.text"
                [variant]="badge.variant"
                [leadingIcon]="badge.leadingIcon"></bl-frontend-badge>
            </div>
          </ng-container>
        </div>
        <p class="py-4 text-sm font-normal text-bl-grey-700" [style]="contentStyle ?? 'min-height: 75px'">
          {{ content }}
        </p>
      </div>
      <div class="absolute bottom-0 mb-4">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  standalone: true,
  imports: [CommonModule, BlFrontendBadgeComponent, BlFrontendHeaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerProgramCardComponent {
  @Input() header: string;
  @Input() content: string;
  @Input() contentStyle: string;
  @Input() background: string;
  @Input() badges?: BadgeProps[];
}
